import type { ArchivedEquipmentItemDto } from '@api/machines'
import { formatPriceAndCurrency } from '@common/utils'
import { MolsonBox, MolsonTypography } from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
import dayjs from 'dayjs'
import { MolsonDatePickerWrapper } from '../molson-date-picker-wrapper'

export const ArchivedItem = ({
  item,
  infoText
}: {
  item: ArchivedEquipmentItemDto
  infoText: string
}) => {
  const { itemName, year, crd, price, brandName } = item
  const theme = molsonUseTheme()

  return (
    <MolsonBox
      sx={{
        p: 3,
        border: `2px solid ${theme.palette.primary.error}`,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 3
      }}
    >
      <MolsonBox>
        <MolsonTypography
          fontSize="0.875rem"
          color={theme.palette.primary.error}
        >
          {infoText}
        </MolsonTypography>
        <MolsonTypography variant="h3">{`${brandName} ${itemName} (${year})`}</MolsonTypography>
      </MolsonBox>
      <MolsonBox sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <MolsonDatePickerWrapper
          sx={{
            maxWidth: 170
          }}
          disabled={true}
          value={dayjs(crd)}
          setValue={() => null}
        />
        <MolsonTypography variant="accent">
          {formatPriceAndCurrency(price)}
        </MolsonTypography>
      </MolsonBox>
    </MolsonBox>
  )
}
